import styled from "styled-components";
import { Layout, Menu, Button, Row, Col } from "antd";
import { Link } from "react-router-dom";
import { Header } from "antd/lib/layout/layout";

const { Content, Sider } = Layout;

interface StyledLinkProps {
  scrolled?: boolean; // Declare the 'scrolled' prop in the interface
}

interface StyledMenuProps {
  scrolled?: boolean; // Declare the 'scrolled' prop in the interface
}

export const StyledContainer = styled(Content)`
  margin-right: 20px;
  display: flex;
  margin-bottom: 20px;
  text-align: left;
  background: white;

  :where(.css-dev-only-do-not-override-3mqfnx).ant-layout {
    background: white;
  }
`;
export const StyledMenu2 = styled(Menu)`
  display: flex;
  border-bottom: 0px;
  line-height: 64px;
  background: #000000ff;
  background: "transparent";
  color: "white";

  @media (max-width: 768px) {
    height: 50px;
    line-height: 50px;
  }

  @media (min-width: 769px) {
    height: 60px;
    line-height: 64px;
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected:after {
    border-bottom: 2px solid whitesmoke;
    color: "white";
    background: #005461;
  }
`;

export const StyledCol = styled(Col)`
  .ant-menu-item {
    height: 90px;
  }
  @media screen and (max-width: 768px) {
    .ant-menu-item {
      height: 60px;
      line-height: 54px;
    }
  }

  @media screen and (max-width: 200px) {
    .ant-menu-item {
      height: 40px;
    }
  }
`;

export const StyledMenu = styled(Menu)<StyledMenuProps>`
  display: flex;
  border-bottom: 0px;
  background: ${({ scrolled }) =>
    scrolled
      ? "#000000ff"
      : "transparent"}; // Conditionally set background color
  transition: background-color 1s; /* color: white; */

  @media (max-width: 768px) {
    height: 50px;
  }

  @media (min-width: 769px) {
    height: 90px;
  }

  &.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected:after {
    border-bottom: 2px solid whitesmoke;
    color: white;
  }

  &.centered-menu {
    justify-content: center !important;

    .ant-menu-item {
      margin: 0 auto !important;
    }
  }

  &.ant-menu-horizontal {
    display: flex;
    justify-content: center;
    align-items: center;

    .ant-menu-item {
      flex: 0 0 auto;
    }
  }
`;

export const StyledLink = styled(Link)<StyledLinkProps>`
  font-family: "Inter";
  text-decoration: none;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (min-width: 769px) {
    font-size: 20px;
  }

  color: ${({ scrolled }) => (scrolled ? "white" : "white")}!important;
  transition: color 0.1s ease;

  &:hover {
    color: ${({ scrolled }) => (scrolled ? "white" : "white")} !important;
    border-bottom: ${({ scrolled }) =>
      scrolled ? " 1px solid white" : " 1px solid white"};
    text-decoration: none;
  }

  &:active,
  &:focus,
  &:visited {
    text-decoration: none;
  }

  img {
    display: block;
    text-decoration: none;
  }
`;
export const StyledHeader = styled(Header)`
  width: 100%;
  height: 0px;
  background: #005461;
  line-height: 40px;
  display: flex;
  align-items: center;
  padding: 32px;
`;

export const StyledHeaderRow = styled(Row)`
  display: flex;
  justify-content: space-between;

  border-bottom: 0px;
`;

export const StyledButton = styled(Button)`
  margin-bottom: 15px;
  background: orange;
  border-color: whitesmoke;
  color: white;

  &:hover {
    color: orange;
    background: white;
    border-color: orange;
  }
`;

export const StyledSider = styled(Sider)`
  &:where(.css-dev-only-do-not-override-3mqfnx).ant-layout
    .ant-layout-sider-trigger {
    position: fixed;
    bottom: 0;
    z-index: 1;
    height: 36px;
    color: #fff;
    text-align: center;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
  }
`;

export const StyledCategoryButton = styled(Button)`
  margin-right: 3px;
  margin-bottom: 3px;

  &:where(.css-dev-only-do-not-override-3mqfnx).ant-btn-default:not(
      :disabled
    ):not(.ant-btn-disabled):hover {
    color: orange;
    border-color: orange;
  }
`;

export const UsernameDropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 2%;
`;

export const StyledGenerateButton = styled(Button)`
  &:where(.css-dev-only-do-not-override-3mqfnx).ant-btn-default {
    background-color: orange;
    border-color: orange;
    color: rgba(0, 0, 0, 0.88);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);

    &:where(.css-dev-only-do-not-override-3mqfnx).ant-btn-default:not(
        :disabled
      ):not(.ant-btn-disabled):hover {
      color: white;
      border-color: orange;
    }
  }
`;
export const StyledMenuButton = styled(Button)`
  &&.ant-btn-text {
    color: white;
    border: none;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 24px;
    text-align: center;
    display: "flex";
    justify-content: center;
    align-items: center;
    border-radius: 0px;

    font-weight: 500;

    &:hover {
      background-color: #005461;
      color: black;
    }
  }
`;
export const StyledMenuButton2 = styled(Button)<StyledLinkProps>`
  &&.ant-btn-text {
    border: none;

    display: "flex";
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      height: 25px;
      font-size: 14px;
      padding: 0 10px;
    }

    @media (min-width: 769px) {
      height: 40px;
      font-size: 24px;
      font-weight: 500;
    }

    &:hover {
      background-color: transparent;
      color: black;
    }
  }
`;

export const StyledRegisterButton = styled(Button)`
  &&.ant-btn-primary {
    border-color: rgb(25, 34, 56);
    background: white;
    box-shadow: none;
    background: #192238;
    color: white;
    border: none;
    border-radius: 5px;
    height: 60px;
    font-size: 22px;
    text-align: center;
    display: "flex";
    justify-content: center;
    align-items: center;
    width: 200px;

    font-weight: 500;

    &:hover {
      background-color: white;
      border-color: white;
      color: black;
    }
  }
`;

export const StyledLoginButton = styled(Button)`
  &&.ant-btn-primary {
    border-color: #de283b;
    background: #de283b;
    color: white;
    border: none;
    box-shadow: none;
    border-radius: 5px;
    font-family: "Lato";
    text-align: center;
    transition: color 0.2s ease;
    display: "flex";
    justify-content: center;
    align-items: center;

    font-weight: 500;
    @media (max-width: 768px) {
      height: 30px;
      font-size: 12px;
      width: 100px;
      margin-right: 5px;
    }

    @media (min-width: 769px) {
      height: 50px;
      font-size: 20px;
      width: 180px;
    }
    &:hover {
      background-color: WHITE;
      border-color: white;
      border: 1px solid #192a53;
      color: #de283b;
      transition:
        background-image 0.5s ease,
        color 0.1s ease;
    }
  }
`;
